import { postToApi } from "venuescanner-js/services/api";
import store from "storejs";
import { STRING } from "venuescanner-js/vanilla/models/ObservablePropTypes";
export const planId = new STRING();
export const availableTrialDays = {
  set: (days) => {
    store.set("availableTrialDays", parseInt(days));
  },
  get: () => {
    // We should get rid of availabeTrialDays altoghether, we don't show free trials anymore
    return null;
  },
};
export const storedCoupon = {
  set: (coupon) => {
    store.set("storedCoupon", JSON.stringify(coupon));
  },
  get: () => {
    const coupon = store.get("storedCoupon");
    try {
      return JSON.parse(coupon);
    } catch (e) {
      return null;
    }
  },
};
export const fetchCoupon = async (code) => {
  const response = await postToApi("subscription/claimCoupon", { code });
  return response.coupon;
};
export const availableDiscount = {
  set: (on) => {
    store.set("availableDiscount", on ? "true" : "false");
  },
  get: () => {
    return store.get("availableDiscount");
  },
};
planId.watch(() => {
  store.set("selectedPlanId", planId.valueOf());
});
export const storedPlan = {
  set: (id) => {
    planId.set(id);
  },
  get: () => {
    planId.set(store.get("selectedPlanId"));
    return planId;
  },
};
export const storedTag = {
  set: (tag) => {
    store.set("selectedPlanTag", tag);
  },
  get: () => {
    return store.get("selectedPlanTag");
  },
};
